"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2865],{

/***/ 2865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _growth_dweb_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3674);



var ClientHeaderGI = function(data) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_growth_dweb_header__WEBPACK_IMPORTED_MODULE_2__/* .Header */ .h4, {
            lobName: "flights",
            onLoginSuccess: function() {
                var ref, ref1;
                window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.reload) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
            },
            onLogoutSuccess: function() {
                var ref, ref1;
                window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.reload) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
            },
            allowInternationalLogin: true,
            hideHeader: false
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ClientHeaderGI);


/***/ })

}]);